// external imports
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { SensorObject } from 'src/app/asp/SensorObject';
import * as utils from './../common/utils';
import * as units from '../common/units';
import { Animations } from './../Animations';
import { AnalyticsMngrService } from '@core_n/msg/analytics-mngr.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CameraInfo, VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { Subscription } from 'rxjs';
import { aspMngr } from '@core_n/asp/AspMngr';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { ObjectType } from '@core_n/asp/AspObject';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { AppInjector } from '@core_n/common/inject';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import {dialogType} from '../enums'
import { DisplayUnits } from '@core_n/common/settings';

@Component({
  selector: 'channels-window',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class ChannelsComponent extends ZIndexMngr implements OnInit, OnDestroy {
  

  public channels: {channel: string, camera: CameraInfo}[] = [];
  // sub
  private channelsSub!: Subscription;

  channelFilter: 'all' | 'fixed' | 'dynamic' = 'all';

  static readonly FIXED_CAMERA_HEAD_LOWER_STR = 'nati'

  get filteredChannels() {
    if (this.channelFilter === 'all') return this.channels;
    const isDynamic = this.channelFilter === 'dynamic';
    return this.channels.filter(ent =>
      ent.channel?.toLowerCase().startsWith(ChannelsComponent.FIXED_CAMERA_HEAD_LOWER_STR) === isDynamic
    );
  }

  constructor(public dialogRef: MatDialogRef<ChannelsComponent>,
    elementRef: ElementRef,
    protected videomngr: VideoMsgMngrService
  ) {
    super(elementRef);

    this.videomngr.updateChannelsTable();

    this.channelsSub! = this.videomngr.ChannelList$.subscribe(map => {
      this.channels = Array.from(map.entries()).map(([channel, camera]) => ({
        channel,
        camera
      }));
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.channelsSub.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
      this.dialogRaise();
    })
  }

  // static createDialogConfig() {
  //   let dialogConfig = utils.createDialogConfig(true);
  //   dialogConfig.panelClass = 'resize';
  //   return dialogConfig;
  // }

  static createDialogConfig() {
    return utils.createDialogConfig(false, false, dialogType.channelsWindow,
      { top: `${100}px`, right: `80px` });
  }

  openAro(cameraName: string) {
    let sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
    if (!sensor)
      sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((cameraName.toLowerCase()).toLowerCase() + ".stream");

    AppInjector.get(AroSensorService).showWindow(sensor as SensorObject);
  }

  removeCamera(cameraName: string,activeStreamName:string) {
    try {
      if(activeStreamName==""){
        this.videomngr.setChannelStreamConnectionState(cameraName, false);
      }
      else{
        this.videomngr.setChannelDaynamicStreamConnectionState(activeStreamName,cameraName,true);
      }
    }
    catch (e) {
      console.error("Cannot remove camera from ztube: " + e);
    }
  }    

  private isFixedCamera(cameraName: string,activeStreamName:string): boolean {
    return (activeStreamName!="" && cameraName.toLowerCase().startsWith(ChannelsComponent.FIXED_CAMERA_HEAD_LOWER_STR));
  }  
  setCenter(cameraName: string,activeStreamName:string) {
    if (this.isFixedCamera(cameraName, activeStreamName)) {
      cameraName = activeStreamName;
    }
    let sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
    if (!sensor)
      sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((cameraName.toLowerCase()).toLowerCase() + ".stream");

    mainMapMngr.setMapCenter(sensor.geometry);
  }  
  private getAdjustedCamera(camera: CameraInfo): CameraInfo {
    if (!camera) return undefined;
    if (!this.isFixedCamera(camera.cameraName, camera.activeStreamName)) return camera;
    const adjustedChannelObj = this.channels.find(c=>c.channel.toLowerCase() == camera.activeStreamName.toLowerCase());
    if (!adjustedChannelObj) return camera;
    return adjustedChannelObj.camera;
  }
  getConnectionStatusColor(camera: CameraInfo): string {
    camera = this.getAdjustedCamera(camera);
    if (!camera) return 'status-missing';
    if (camera.hasInStream == null) return 'status-missing'; // missing - grey color
    if (camera.hasInStream === false) return 'status-disconnected'; // disconnected - red color
    if (camera.hasInStream === true && camera.hasOutStream) return 'status-ok'; // ok - green color
    if (camera.hasInStream === true && !camera.hasOutStream) return 'status-unconsumed'; // unconsumed - yellow color
    return 'status-missing';
  }
  getConnectionStatusTooltip(camera: CameraInfo): string {
    camera = this.getAdjustedCamera(camera);
    if (!camera) return '';
    const dateStr = camera.connectionStatusLastUpdateDate || '';
    let stateText = '';
    if (camera.hasInStream == null) {
      stateText = 'המצלמה לא מוגדרת בוידאו'; // missing - grey color
    } else if (camera.hasInStream === false) {
      stateText = 'אין שידור נכנס'; // disconnected - red color
    } else if (camera.hasInStream === true && camera.hasOutStream) {
      stateText = 'משדר'; // ok - green color
    } else if (camera.hasInStream === true && !camera.hasOutStream) {
      stateText = 'השידור לא יוצא'; // unconsumed - yellow color
    }
    return dateStr ? `${stateText} (עודכן: ${dateStr})` : stateText;
  }
}